// @ts-nocheck
import { createBrowserHistory, History } from '/data1/jenkins/workspace/aplus_tiger_h5_game_details_share_page_202204251659490524a1d2-5835-4a76-a8b1-7acfca817b0e_tiger-platform_gamecenter_h5_game_details_share_page_20220425165949_48687_nodejs_prod/node_modules/@umijs/runtime';

let options = {
  "basename": "/h5/h5_game_details_share_page/"
};
if ((<any>window).routerBase) {
  options.basename = (<any>window).routerBase;
}

// remove initial history because of ssr
let history: History = process.env.__IS_SERVER ? null : createBrowserHistory(options);
export const createHistory = (hotReload = false) => {
  if (!hotReload) {
    history = createBrowserHistory(options);
  }

  return history;
};

export { history };
